import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });
const url = `${baseURL}/v1/queues`;

export interface QueueOverview {
  messages: { queued: number; sending: number; sent24h: number; failed: number; oldestQueuedSeconds: number; delivered24h: number; undelivered24h: number };
  invites: { queued: number; sending: number; sent24h: number; failed: number; oldestQueuedSeconds: number; delivered24h: number; undelivered24h: number };
  videos: { queued: number; processing: number; done24h: number; failed: number };
  workerTickSeconds: number;
}

export interface QueuedMessage {
  id: string;
  channel: "sms" | "email";
  to: string;
  kind: string;
  priority: number;
  status: "queued" | "sending" | "sent" | "failed";
  attempts: number;
  lastError: string;
  nextAttemptAt: string | null;
  createdAt: string;
  sentAt: string | null;
  refId: string;
  provider: string;
  /** SMS: the provider's delivery report; mail: accepted by the mail server */
  delivery: { status: string; at?: string; detail?: string } | null;
}

export const getQueueOverview = async (): Promise<QueueOverview | null> => {
  try {
    return (await axios.get(url, headers())).data;
  } catch {
    return null;
  }
};

export const getQueuedMessages = async (status?: string): Promise<{ results: QueuedMessage[]; total: number } | null> => {
  try {
    return (await axios.get(`${url}/messages`, { ...headers(), params: { status: status || undefined, limit: 100 } })).data;
  } catch {
    return null;
  }
};

export const retryMessage = async (id: string): Promise<boolean> => {
  try {
    await axios.post(`${url}/messages/${id}/retry`, {}, headers());
    return true;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke sætte beskeden i kø igen", false);
    return false;
  }
};

export const retryFailedMessages = async (): Promise<number | null> => {
  try {
    return (await axios.post(`${url}/messages/retry-failed`, {}, headers())).data?.retried ?? 0;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Kunne ikke sætte beskederne i kø igen", false);
    return null;
  }
};
